import { message } from 'antd'
import { HttpMethod, apiRequest } from './api'

// 登录请求参数
export interface LoginRequest {
  username: string
  password: string
}

// 登录响应数据
export interface LoginResponse {
  access_token: string
  refresh_token: string
}

// 管理员登录
export async function adminLogin(credentials: LoginRequest) {
  const response = await apiRequest<LoginResponse>('/user/adminLogin', {
    method: HttpMethod.POST,
    body: credentials,
  })

  // 登录成功后保存双 token
  if (response.code === '200') {
    localStorage.setItem('access_token', response.data.access_token)
    localStorage.setItem('refresh_token', response.data.refresh_token)
    // 清理旧的 token 字段（如果存在）
    localStorage.removeItem('token')
  } else {
    message.error(response.msg || '登录失败，请检查用户名和密码是否正确')
  }

  return response
}

// 退出登录
export function logout() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  // 清理旧的 token 字段（如果存在）
  localStorage.removeItem('token')
}

// 检查是否已登录
export function isAuthenticated(): boolean {
  return !!localStorage.getItem('access_token')
}

// 获取当前 access_token
export function getAccessToken(): string | null {
  return localStorage.getItem('access_token')
}

// 获取当前 refresh_token
export function getRefreshToken(): string | null {
  return localStorage.getItem('refresh_token')
}

// 管理员注册请求参数
export interface AdminRegisterRequest {
  username: string
  password: string
}

// 管理员注册
export async function adminRegister(credentials: AdminRegisterRequest) {
  const response = await apiRequest('/user/adminRegister', {
    method: HttpMethod.POST,
    body: credentials,
  })

  if (response.code === '200') {
    message.success('管理员注册成功')
  } else {
    message.error(response.msg || '管理员注册失败')
  }

  return response
}

// 用户角色响应接口
export interface UserRolesResponse {
  userId: number
  roles: Array<string>
}

// 获取用户角色
export async function getUserRoles(params?: {
  pageNum?: string
  pageSize?: string
}) {
  const response = await apiRequest<UserRolesResponse>('/user/roles', {
    method: HttpMethod.GET,
    params,
  })

  return response
}
